// 教师/后台角色判断：供登录分流与头像跨端菜单共用。

const TEACHER_ROLE_KEYS = new Set(["teacher", "teacherleader"]);
// 独立后台地址；本地联调开关开启后，管理员通过整页导航进入该项目。
const EXTERNAL_ADMIN_URL = "https://b.szshipian.com/admin";

/** 将角色编码统一为小写，便于比较 */
function normalizeRoles(roles: string[]): string[] {
  return roles.map((role) => role.toLowerCase());
}

/**
 * 是否含教师端角色（teacher / teacherLeader）
 * @param roles 用户角色编码列表
 */
export function hasTeacherRole(roles: string[]): boolean {
  return normalizeRoles(roles).some((role) => TEACHER_ROLE_KEYS.has(role));
}

/**
 * 是否含后台角色（存在任意非纯教师角色，如 admin、platformAdmin）
 * @param roles 用户角色编码列表
 */
export function hasBackendRoleAccess(roles: string[]): boolean {
  return normalizeRoles(roles).some((role) => !TEACHER_ROLE_KEYS.has(role));
}

/**
 * 按角色返回默认系统首页
 * @param roles 用户角色编码列表
 */
export function resolveDefaultHomePath(roles: string[]): string {
  if (hasTeacherRole(roles) && !hasBackendRoleAccess(roles)) {
    return "/office/workbench";
  }
  return "/dashboard";
}

/** 是否为 Office 教师端路径 */
export function isOfficePath(path: string): boolean {
  return path === "/office" || path.startsWith("/office/");
}

/**
 * 是否启用独立后台入口
 * @returns 仅当 Vite 环境变量明确配置为 true 时启用
 */
export function isExternalAdminEnabled(): boolean {
  return import.meta.env.VITE_USE_EXTERNAL_ADMIN === "true";
}

/**
 * 按配置跳转到独立后台；未启用时由调用方继续使用当前项目后台。
 * @param replace 是否替换当前浏览历史，登录默认落地时用于避免返回后重复跳转
 * @returns 是否已经发起独立后台跳转
 */
export function redirectToExternalAdmin(replace = false): boolean {
  if (!isExternalAdminEnabled()) return false;

  if (replace) {
    window.location.replace(EXTERNAL_ADMIN_URL);
  } else {
    window.location.assign(EXTERNAL_ADMIN_URL);
  }
  return true;
}

/**
 * 在新窗口打开独立后台；未启用时由调用方继续使用当前项目后台。
 * @returns 是否已经发起独立后台打开操作
 */
export function openExternalAdminWindow(): boolean {
  if (!isExternalAdminEnabled()) return false;

  // noopener、noreferrer 避免新后台页面反向控制当前 Office 窗口。
  window.open(EXTERNAL_ADMIN_URL, "_blank", "noopener,noreferrer");
  return true;
}
